import ApiService from "@/common/api/api.service";

const DashboardAdminService = {
    projetosCadastrados : function() {
        return ApiService.get(`/dashboardAdmin/projetos-cadastrados`);
    },
    empresasCadastradas : function() {
        return ApiService.get(`/dashboardAdmin/empresas-cadastradas`);
    },
    liberacoesPendentes : function() {
        return ApiService.get(`/dashboardAdmin/liberacoes-pendentes`);
    },
    empresasEncerradas : function() {
        return ApiService.get(`/dashboardAdmin/empresas-encerradas`);
    },
    empresasPorEstado : function() {
        return ApiService.get(`/dashboardAdmin/empresas-por-estado`);
    },
    empresasPorRegiao : function() {
        return ApiService.get(`/dashboardAdmin/empresas-por-regiao`);
    },
    usuariosPorRegiao : function() {
        return ApiService.get(`/dashboardAdmin/usuarios-por-regiao`);
    },
    empresasPorSegmento : function() {
        return ApiService.get(`/dashboardAdmin/empresas-por-segmento`);
    },
    saldoAInvestir : function() {
        return ApiService.get(`/dashboardAdmin/saldo-a-investir`);
    },
    contratos : function(){
        return ApiService.get(`/dashboardAdmin/contratos`);
    }

};

export default DashboardAdminService;
